import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { PartnerQueryRenderer, PerkQueryRenderer } from "../screens/Club";
import {
  RouteProp,
  getFocusedRouteNameFromRoute,
} from "@react-navigation/native";
import { useLayoutEffect } from "react";
import { HomeTabsParamList } from "./HomeTabsNavigator";
import { ClubScreen } from "../screens/Club/ClubScreen/ClubScreen";

export type ClubNavigatorParamList = {
  ClubScreen: undefined;
  Partner: { partnerId: string };
  Perk: { perkId: string; partnerId: string };
};

const Stack = createNativeStackNavigator<ClubNavigatorParamList>();

const tabBarHiddenRoutes = ["Perk", "Partner"];

export const ClubNavigator = ({
  navigation,
  route,
}: {
  navigation: any;
  route: RouteProp<HomeTabsParamList, "club">;
}) => {
  useLayoutEffect(() => {
    const routeName = getFocusedRouteNameFromRoute(route);

    if (tabBarHiddenRoutes.includes(routeName ?? "")) {
      navigation.setOptions({ tabBarStyle: { display: "none" } });
    } else {
      navigation.setOptions({ tabBarStyle: { display: "flex" } });
    }
  }, [navigation, route]);

  return (
    <Stack.Navigator screenOptions={{ headerShown: false, title: "Club" }}>
      <Stack.Screen name="ClubScreen" component={ClubScreen} />
      <Stack.Screen
        name="Partner"
        component={PartnerQueryRenderer}
        options={{
          presentation: "fullScreenModal",
        }}
      />
      <Stack.Screen
        name="Perk"
        component={PerkQueryRenderer}
        options={{
          presentation: "formSheet",
        }}
      />
    </Stack.Navigator>
  );
};
